import { stagger, Transition, Variants } from 'motion/react'

// Every timing of the theme filter's animation in seconds.
// The overlay fades in, then the buttons pop in one after the other and the close button spins in,
// on close the buttons and the close button fade out at once while the overlay fades away.
// Once a button has popped in it keeps pulsing, each one starting at a random point so they don't pulse in sync
export const filterTiming = {
  overlay: { duration: 0.5 },
  open: {
    // overshoots a bit, so the round buttons pop
    button: { duration: 0.45, ease: [0.34, 1.56, 0.64, 1] },
    closeButton: { delay: 0.2, duration: 0.5, ease: [0.2, 0, 0, 1] },
    // the buttons start once the overlay has mostly faded in
    buttonDelay: 0.15,
    buttonStagger: 0.07,
  },
  close: {
    button: { duration: 0.15, ease: [0.4, 0, 0.2, 1] },
    closeButton: { duration: 0.15, ease: [0.4, 0, 0.2, 1] },
  },
  pulse: {
    duration: 3,
    // css' ease, applied between every keyframe
    ease: [0.25, 0.1, 0.25, 1],
    maxDelay: 2.2,
  },
} as const

export const overlayVariants: Variants = {
  hidden: { opacity: 0, transition: filterTiming.overlay },
  visible: {
    opacity: 1,
    transition: {
      ...filterTiming.overlay,
      delayChildren: stagger(filterTiming.open.buttonStagger, {
        startDelay: filterTiming.open.buttonDelay,
      }),
    },
  },
}

// the filter buttons, they follow the overlay's variant
export const buttonVariants: Variants = {
  hidden: { opacity: 0, scale: 0.6, transition: filterTiming.close.button },
  visible: { opacity: 1, scale: 1, transition: filterTiming.open.button },
}

export const closeButtonVariants: Variants = {
  hidden: { opacity: 0, scale: 0.5, rotate: -90, transition: filterTiming.close.closeButton },
  visible: { opacity: 1, scale: 1, rotate: 0, transition: filterTiming.open.closeButton },
}

export const pulseKeyframes = {
  scale: [1, 0.95, 1, 1.05, 1],
  boxShadow: [
    '0 0 0 0 rgba(0, 0, 0, 0.15)',
    '0 0 16px 4px rgba(0, 0, 0, 0.1)',
    '0 0 16px 4px rgba(0, 0, 0, 0.1)',
    '0 0 16px 4px rgba(0, 0, 0, 0.1)',
    '0 0 0 0 rgba(0, 0, 0, 0.15)',
  ],
}

export const getRandomPulseDelay = () => Math.random() * filterTiming.pulse.maxDelay

export const getPulseTransition = (delay: number): Transition => ({
  duration: filterTiming.pulse.duration,
  ease: filterTiming.pulse.ease,
  repeat: Infinity,
  delay,
})
